
	import {
		Component,
		Model,
		Prop,
		Vue,
		Watch
	} from "vue-property-decorator";
	
	import html2canvas from 'html2canvas';
	import { imgHost } from '@/utils/config';
	
	import {
		orderReceipt
	} from '@/api/order';

	@Component({
		name: 'receipt-view',
		components: {}
	})
	
	export default class ReceiptView extends Vue {
		// @Model('change') orderNo: string;
		@Prop({}) private orderNo: string;
		@Prop({}) private orderdata: any;
		private hostUrl = location.origin;
		private imgHost:string = imgHost;
		private htmlLoading = false;
		private orderInfo: object = {
			Groups: []
		};
		private viewName: string = '';
		private noViewName: string = '';
		private viewPhone: string = '';
		private noViewPhone: string = '';
		private viewAddress: string = '';
		private noViewAddress: string = '';
		private isOpenEyes:boolean = false;
		private canvasUrl: string = '';


		@Watch('orderNo')
		private onChangeShow(val:string) {
			if (val) {
				this.getData();
			}
		}
		
		private mounted(){
			if (this.orderNo){
				this.getData();
			}
		}

		private async getData() {
			let params: any = {
				OrderNo: this.orderNo 
			};
			
			this.htmlLoading = true;
			try {
				const res: any = await orderReceipt(params);
				if (res.IsSuccess){
					this.viewName = res.Result.ReceiveName;
					this.noViewName = res.Result.ReceiveName.substr(0, 1) + '***';
					
					this.viewPhone = res.Result.ReceivePhone;
					this.noViewPhone = res.Result.ReceivePhone.substr(0, 3) + '****' + res.Result
						.ReceivePhone.substr(7, 4);
					
					var address = res.Result.ReceiveProvince + res.Result.ReceiveCity + res.Result
						.ReceiveArea + res.Result.ReceiveAddress;
					this.viewAddress = address;
					this.noViewAddress = address.substr(0, 2) + '*****' + address.substr(address
						.length - 4, 4);
					
					this.orderInfo = res.Result;
					
					const nextTick:any = this.$nextTick;
					nextTick(()=>{
						this.createCanvas();
					})
				}
			}finally{
				// this.htmlLoading = false;
			}
		}
		
		
		private createCanvas(){
			html2canvas(document.querySelector('.receipt-content'), {
				useCORS: true, // 【重要】开启跨域配置
				scale: 2,
				allowTaint: true, // 允许跨域图片
				logging:false,
			}).then((canvas)=>{
				this.htmlLoading = false;
				this.canvasUrl = canvas.toDataURL('image/jpeg');
			});
		}
	}
